import { showModal } from '@phoenix/helpers/modal-helper';

export default {
  props: {
    findWatchReferenceModalId: {
      type: String,
      default: '',
    },
  },

  methods: {
    openFindWatchReferenceModal() {
      showModal(this.findWatchReferenceModalId);
    },
  },
};
